export default __webpack_public_path__ + "static/media/Wordpress_Park_Springs_Atlantas_Premier_Life_Plan_Community.630fd7ab.png";